/**
 * Primavera P6 .xer decoding and text cleanup (browser).
 * XER exports are often Windows-1252 / Latin-1; reading as UTF-8 causes mojibake.
 */

/**
 * @param {ArrayBuffer} arrayBuffer
 * @returns {string}
 */
export function decodeP6XerBytes(arrayBuffer) {
    const bytes = new Uint8Array(arrayBuffer);
    try {
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    } catch (e) {
        try {
            return new TextDecoder('windows-1252').decode(bytes);
        } catch (e2) {
            return new TextDecoder('iso-8859-1').decode(bytes);
        }
    }
}

/**
 * Mainly for Primavera P6 .xer import
 * @param {string|null|undefined} str
 * @returns {string}
 */
export function sanitizeP6ImportText(str) {
    if (str == null || str === '') {
        return '';
    }
    let s = String(str)
        .replace(/\uFEFF/g, '')
        .normalize('NFC');
    s = s.replace(/\uFFFD/g, '');
    return s.trim();
}
